module.exports = __webpack_public_path__ + "img/fagndajing.00313b4f.png";